import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "chat" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseEditor = _resolveComponent("BaseEditor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BaseEditor, {
      value: _ctx.htmlString,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_ctx.htmlString = $event))
    }, null, 8, ["value"])
  ]))
}